<template>
  <div
    class="portfolios-card"
    :class="`portfolios-card--${portfolio.portfolio_type}`"
  >
    <button
      class="portfolios-card__delete"
      @click="onDeleteClick"
    >
      {{ $t('common.delete') }}
    </button>
    <div class="portfolios-card__content">
      <span class="portfolios-card__icon" />
      <h3 class="portfolios-card__title">
        {{ portfolio.name }}
      </h3>
      <component
        :is="component"
        :overview="portfolio.overview"
      />

      <div class="portfolios-card__footer">
        <a
          :href="$url(portfolio.path)"
          :title="$t('portfolios.card.link_title')"
          class="portfolios-card__link"
        >
          {{ $t('buttons.view') }}
        </a>
  
        <DashboardTooltip
          v-if="hasInvalidCompanies"
          class="portfolios-card__tooltip"
          type="warning"
          :tooltip="invalidCompanyWarning"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTooltip from '~/components/dashboard/DashboardTooltip'
import OverviewsAgriculture from './overviews/Agriculture'
import OverviewsMining from './overviews/Mining'
import OverviewsNaturalCapital from './overviews/NaturalCapital'

import { portfolioHasInvalidCompany } from './helpers/invalid-companies'

export default {
  components: {
    DashboardTooltip,
    OverviewsAgriculture,
    OverviewsMining,
    OverviewsNaturalCapital,
  },

  props: {
    portfolio: {
      type: Object,
      required: true
    }
  },

  computed: {
    component () {
      return `overviews-${this.portfolio.portfolio_type.replace('_', '-')}`
    },

    hasInvalidCompanies () {
      if (this.portfolio.portfolio_type === 'mining') {
        return portfolioHasInvalidCompany(this.portfolio)
      }

      return false
    },

    invalidCompanyWarning () {
      return this.$t('biodiversity_goals.portfolio.forms.mining.invalid_portfolio_warning')
    }
  },

  methods: {
    onDeleteClick () {
      this.$root.$emit('show-portfolios-delete-modal', {
        show: true,
        portfolio: this.portfolio
      })
    }
  }
}
</script>
